import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { updateSurvey } from '../Services/Surveys.service';
import type { SurveyUpdatePayload } from '../Types/Surveys.types';
import { useActionToast } from '@/Hooks/useActionToast';

export const useUpdateSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: SurveyUpdatePayload }) =>
      updateSurvey(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível salvar a pesquisa', error);
    },
  });
};
